"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RESIZE_DEBOUNCE_MS = exports.IGNORE_NON_TOUCH_EVENTS_MS = void 0;
var IGNORE_NON_TOUCH_EVENTS_MS = 200;
exports.IGNORE_NON_TOUCH_EVENTS_MS = IGNORE_NON_TOUCH_EVENTS_MS;
var RESIZE_DEBOUNCE_MS = 166;
exports.RESIZE_DEBOUNCE_MS = RESIZE_DEBOUNCE_MS;
var _default = {
  IGNORE_NON_TOUCH_EVENTS_MS: IGNORE_NON_TOUCH_EVENTS_MS,
  RESIZE_DEBOUNCE_MS: RESIZE_DEBOUNCE_MS
};
exports["default"] = _default;